import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonialImages } from '../../data/testimonialImages';
export function Testimonials() {
  const scrollerRef = useRef<HTMLDivElement>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [visibleIndexes, setVisibleIndexes] = useState<Set<number>>(new Set([0]));
  const activeIndex = visibleIndexes.size ? Math.min(...visibleIndexes) : 0;
  useEffect(() => {
    const root = scrollerRef.current;
    if (!root) return;
    const observer = new IntersectionObserver(entries => {
      setVisibleIndexes(prev => {
        const next = new Set(prev);
        entries.forEach(entry => {
          const idx = Number((entry.target as HTMLElement).dataset.index);
          if (entry.isIntersecting) {
            next.add(idx);
          } else {
            next.delete(idx);
          }
        });
        return next;
      });
    }, {
      root,
      threshold: 0.6
    });
    cardRefs.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);
  function scrollToIndex(index: number) {
    cardRefs.current[index]?.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });
  }
  const goPrev = () => scrollToIndex(Math.max(activeIndex - 1, 0));
  const goNext = () => scrollToIndex(Math.min(activeIndex + 1, testimonialImages.length - 1));
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-220" data-mp="26jsj58i6xnnc">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-221" data-mp="26l3p9ez3z7hm">
        <h2 className="font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-222" data-mp="22hnoq7jx4mzn">
          Así están usando el material otros entrenadores
        </h2>
      </div>

      <div className="relative mx-auto mt-10 max-w-3xl px-8 sm:px-12" data-id="element-223" data-mp="r438s6zv133c">
        <button type="button" onClick={goPrev} disabled={activeIndex === 0} aria-label="Testimonio anterior" className="absolute left-0 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-gris-claro bg-white text-marino shadow-leve transition-opacity disabled:opacity-30 sm:h-11 sm:w-11" data-id="element-224" data-mp="m4gs1nktp4ps">
          <ChevronLeftIcon size={18} data-id="element-225" data-mp="enambh6e6xnx" />
        </button>
        <button type="button" onClick={goNext} disabled={activeIndex === testimonialImages.length - 1} aria-label="Siguiente testimonio" className="absolute right-0 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-gris-claro bg-white text-marino shadow-leve transition-opacity disabled:opacity-30 sm:h-11 sm:w-11" data-id="element-226" data-mp="il8787t4qxli">
          <ChevronRightIcon size={18} data-id="element-227" data-mp="3w1pi9iawf81j" />
        </button>

        <div ref={scrollerRef} className="scrollbar-hide flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth" data-id="element-228" data-mp="3i1en432k37ak">
          {testimonialImages.map((item, i) => <div key={item.image} ref={el => cardRefs.current[i] = el} data-index={i} className="flex h-[420px] w-full flex-shrink-0 snap-start items-center justify-center sm:h-[500px] sm:w-[calc(50%-8px)]" data-id="element-229" data-mp="33g0sk4dhk7wv" data-mpi={i}>
              <img src={item.image} alt={item.alt} loading="lazy" decoding="async" className="max-h-full max-w-full rounded-2xl object-contain" data-id="element-230" data-mp="38dj5e5umj7a5" />
            </div>)}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2" data-id="element-231" data-mp="3w3n4q10s4kvc">
          {testimonialImages.map((item, i) => <button key={item.image} type="button" onClick={() => scrollToIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} aria-current={activeIndex === i} className={`h-2 rounded-full transition-all duration-200 ${activeIndex === i ? 'w-6 bg-naranja-strong' : 'w-2 bg-gris-claro'}`} data-id="element-232" data-mp="3r40l99ucy8e3" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}